import type { FeatureFlags } from './feature-flags.types';

/**
 * Static feature flags configuration
 *
 * To enable/disable features:
 * 1. Change the boolean value for the desired feature
 * 2. Commit and deploy the changes
 *
 * @example
 * // To enable V2 revamp
 * 'revamp.v2': true,
 *
 * // To disable V2 revamp
 * 'revamp.v2': false,
 */
export const FEATURE_FLAGS: FeatureFlags = {
  'revamp.v2': true, // V2 UI revamp - currently enabled for testing
} as const;
